export default __webpack_public_path__ + "static/meta-3ca956de16563eb252657663d59363e7.jpg";